import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Auth-aware root route for `app.blueharborlabs.app`.
 *
 * Behaviour:
 *   - Loading (auth not resolved yet)  -> tiny spinner.
 *   - Logged out                        -> /login (no marketing landing).
 *   - Logged in admin or manager        -> /admin.
 *   - Logged in employee (default)      -> /scan.
 *
 * The marketing landing page lives on the apex domain
 * `blueharborlabs.app`. This subdomain is the app, so `/` jumps
 * straight into the appropriate post-login surface.
 */
export default function RootRedirect() {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-paper"
        data-testid="root-redirect-loading"
      >
        <div className="font-mono text-sm text-muted-foreground">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace data-testid="root-redirect-login" />;
  }

  let dest;
  if (user.role === "platform_superadmin") {
    dest = "/platform";
  } else if (user.role === "admin" || user.role === "manager") {
    dest = "/admin";
  } else {
    dest = "/scan";
  }
  return <Navigate to={dest} replace data-testid="root-redirect-app" />;
}
